import { replaceQueryString } from "@client/lib/api";
import { type OptionItem } from "@common/declarations";

export const redirect = (tenant: OptionItem<string>, email: string) => {
  const url = `https://${tenant.label}`;

  window.location.replace(replaceQueryString(`${url}/admin`, { email: email }));
};
